import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { fDateTime } from "src/utils/formatTime";
import Iconify from "../iconify";

const getStatusName = (status) => {
  switch (status) {
    case 0:
      return "Draft";
    case 1:
      return "Active";
    case 2:
      return "Inactive";
    default:
      return "Unknown";
  }
};

const getRuleTypeName = (ruleType) => {
  switch (ruleType) {
    case 0:
      return "In App Purchase Spending";
    case 1:
      return "In App Purchase Buy Item";
    case 2:
      return "Login Streak";
    case 3:
      return "Open Packs";
    case 4:
      return "Division Promotion";
    case 5:
      return "Signup";
    default:
      return "Unknown";
  }
};
const getApplyGroupName = (applyGroupType) => {
  switch (applyGroupType) {
    case 0:
      return "All";
    case 1:
      return "Inbox Groups";
    case 2:
      return "Specific Users";
    case 3:
      return "Player Levels";
    default:
      return "Unknown";
  }
};

export default function PromotionsTable(props) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPromotion, setSelectedPromotion] = useState(null);

  const handleMenuOpen = (event, promotion) => {
    setAnchorEl(event.currentTarget);
    setSelectedPromotion(promotion);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedPromotion(null);
  };

  const handleEdit = () => {
    if (selectedPromotion) {
      navigate(
        `/dashboard/promotions/promotion?promotion_id=${selectedPromotion.promotionId}`
      );
    }
    handleMenuClose();
  };

  const handleRewards = () => {
    if (selectedPromotion) {
      navigate(`/dashboard/promotions/${selectedPromotion.promotionId}/rewards`);
    }
    handleMenuClose();
  };

  const handleDelete = () => {
    if (selectedPromotion && props.onDelete) {
      props.onDelete(selectedPromotion);
    }
    handleMenuClose();
  };

  const handleDuplicate = () => {
    if (selectedPromotion && props.onDuplicate) {
      props.onDuplicate(selectedPromotion);
    }
    handleMenuClose();
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Promo ID</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Rule Type</TableCell>
            <TableCell>Apply Group</TableCell>
            <TableCell>Redemptions</TableCell>
            <TableCell>Period</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.promotions?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.promotionId}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.title}
              </TableCell>
              <TableCell component="th" scope="row">
                {getRuleTypeName(row.ruleType)}
              </TableCell>
              <TableCell component="th" scope="row">
                {getApplyGroupName(row.applyGroupType)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.redemptionsCount}
              </TableCell>
              <TableCell component="th" scope="row">
                {fDateTime(row.startDate)} - {!row.hasExpiration ? 'No End Date' : fDateTime(row.endDate)}
              </TableCell>
              <TableCell component="th" scope="row">
                {getStatusName(row.status)}
              </TableCell>
              <TableCell component="th" scope="row">
                <IconButton
                  onClick={(event) => handleMenuOpen(event, row)}
                  size="small"
                >
                  <Iconify icon="eva:more-vertical-fill" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEdit}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 1 }} />
          Edit
        </MenuItem>
        <MenuItem onClick={handleRewards}>
          <Iconify icon="eva:gift-fill" sx={{ mr: 1 }} />
          Rewards
        </MenuItem>
        <MenuItem onClick={handleDuplicate}>
          <Iconify icon="eva:copy-fill" sx={{ mr: 1 }} />
          Duplicate
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <Iconify icon="eva:trash-2-fill" sx={{ mr: 1 }} />
          Delete
        </MenuItem>
      </Menu>
    </TableContainer>
  );
}
